import PriceCalculator from '../components/PriceCalculator';
import ReviewSlider from '../components/ReviewSlider';
import { COMPANY_INFO } from '../data/staticData';

export default function PriceCalculatorPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16">
      
      {/* Price Calculator Component with the 4 exact options */}
      <PriceCalculator />

      {/* Scraped Informational Content from dansktagbyg.dk/p/prisberegner-tag */}
      <div className="bg-stone-50 border border-stone-200 p-8 sm:p-12 space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          
          <div className="space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-stone-900 tracking-tight">
              Hvad tager en nyt tag prisberegner højde for?
            </h3>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              En korrekt pris på et nyt tag afhænger af flere faktorer. Vores beregner er bygget på erfaring fra konkrete projekter og tager højde for:
            </p>
            <ul className="space-y-2 text-stone-700 text-sm sm:text-base">
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                <span>Tagets hældning</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                <span>Valg af tagtype (fx tegltag, betontag eller eternittag)</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                <span>Tagets vinkel</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-[#42b732] font-bold"></i>
                <span>Størrelsen på huset grundplan</span>
              </li>
            </ul>
            <p className="text-stone-600 text-sm leading-relaxed pt-1">
              Det betyder, at du ikke får en tilfældig standardpris – men et estimat, der ligger tæt på det, du reelt kan forvente.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-stone-900 tracking-tight">
              Et bedre beslutningsgrundlag – før du taler med en håndværker
            </h3>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              Mange boligejere kontakter flere tagfirmaer uden at have et klart billede af budgettet. Det skaber usikkerhed – og ofte også dårlige beslutninger.
            </p>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              Med vores nyt tag prisberegner står du stærkere fra start. Du får:
            </p>
            <ul className="space-y-2 text-stone-700 text-sm sm:text-base">
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                <span>Indblik i prisniveauet</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                <span>Mulighed for at sammenligne tagtyper</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-circle-check text-[#42b732]"></i>
                <span>Et bedre grundlag for dialog med håndværkere</span>
              </li>
            </ul>
            <p className="text-stone-600 text-sm leading-relaxed pt-1">
              Det gør hele processen mere overskuelig – og minimerer risikoen for ubehagelige overraskelser.
            </p>
          </div>

        </div>

        <div className="pt-8 border-t border-stone-200 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          
          <div className="space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-stone-900 tracking-tight">
              Fra prisestimat til færdigt tag
            </h3>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              Når du har brugt vores prisberegner, er næste skridt enkelt. Hvis du ønsker det, gennemgår vi dit projekt i detaljer og giver dig et konkret tilbud baseret på din bolig.
            </p>
            <p className="text-stone-600 text-sm leading-relaxed">
              Her tager vi højde for de ting, en beregner ikke kan se:
            </p>
            <ul className="space-y-2 text-stone-700 text-sm">
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-arrow-right text-[#42b732] text-xs"></i>
                <span>Tagets faktiske stand</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-arrow-right text-[#42b732] text-xs"></i>
                <span>Konstruktionens opbygning</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-arrow-right text-[#42b732] text-xs"></i>
                <span>Lokale forhold</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-arrow-right text-[#42b732] text-xs"></i>
                <span>Eventuel efterisolering</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-arrow-right text-[#42b732] text-xs"></i>
                <span>Nedtagning og bortskaffelse af eksisterende tag</span>
              </li>
            </ul>
            <p className="text-stone-600 text-sm leading-relaxed font-semibold">
              Det sikrer, at du får en løsning, der holder – både teknisk og økonomisk.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-stone-900 tracking-tight">
              Derfor vælger boligejere Dansk Tagbyg
            </h3>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              Når du investerer i et nyt tag, er det afgørende at vælge en samarbejdspartner, du kan regne med – både fagligt og menneskeligt.
            </p>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              Hos Dansk Tagbyg har vi fokus på at levere en tryg og gennemskuelig proces fra start til slut:
            </p>
            <ul className="space-y-2 text-stone-700 text-sm">
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-star text-amber-500"></i>
                <span><strong>4,8/5 stjerner</strong> baseret på +150 anmeldelser</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-location-dot text-[#42b732]"></i>
                <span>Landsdækkende service til både private og erhverv</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-user-check text-[#42b732]"></i>
                <span>Fast kontaktperson gennem hele projektet</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-certificate text-[#42b732]"></i>
                <span>Arbejde udført efter gældende branchestandarder</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-shield-check text-[#42b732]"></i>
                <span>Garantiordninger (Byg Garanti og op til 30 års produktgaranti)</span>
              </li>
            </ul>
            <div className="pt-2">
              <a
                href={COMPANY_INFO.phoneTel}
                className="nowrap-contact inline-flex items-center gap-2 px-4 py-2 bg-[#42b732] hover:bg-[#389e2b] text-white font-bold text-xs uppercase tracking-wider transition-colors"
              >
                <i className="fa-solid fa-phone"></i> Ring til os: {COMPANY_INFO.phoneFormatted}
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Review Carousel */}
      <ReviewSlider />

    </div>
  );
}
